export default "__VITE_ASSET__D7W7wOo1__"